import styles from '@/styles/About.module.css'
import Head from 'next/head'
import dynamic from 'next/dynamic'

const RegularPizza = dynamic(() => import('@/components/RegularPizza'))

const Page = () => {
  return (
    <main className={styles.main}>
      <Head>
        <title>La Bambi Restaurang - Standard Pizzor Meny</title>
        <meta
          name='description'
          content='En klassiker som aldrig går fel. Vår standardpizza är en perfekt balans mellan en krispig botten, en krämig tomatsås och en smakrik ostblandning. Toppa med dina favorittillbehör för en pizza som passar alla smaker. Njut av en smakrik och klassisk pizza från [Restaurang La Bambi]!'
        />
        <meta name='viewport' content='width=device-width, initial-scale=1' />
      </Head>
      <RegularPizza title='Alla pizzor innehåller tomatsås och ost' />
    </main>
  )
}

export default Page
